/* eslint-disable */
export default {
  authServiceUrl: process.env.AUTHENTICATION_SERVICE_URL,
  bossLoginUrl: process.env.BOSS_LOGIN_URL,
  devJWT: process.env.DEV_JWT,
  embeddedTimeUIURL: process.env.EMBED_TIMEUI_URL,
  environment: process.env.NODE_ENV,
  isDeployedBuild: process.env.IS_DEPLOYED_BUILD,
  mdsApiUrl: process.env.MDSAPI_EXTERNAL_URL,
  mdsuiEmbedURL: process.env.MDSUI_EMBED_URL,
  partnerURL: process.env.PARTNER_PORTAL_URL,
  publicPath: process.env.PUBLIC_PATH,
  tsApiUrl: process.env.TS_API_URL,
  timeLaborURL: process.env.MANAGER_PORTAL_URL,
  timeSimplicityUrl: process.env.TIMESIMPLICITY_URL,
  twpApiURL: process.env.TWP_API_URL,
  webclockEmbedURL: process.env.WEBCLOCK_EMBED_URL,
  appEnv: process.env.APP_ENV,
  devLoginUserName: process.env.DEV_LOGIN_USERNAME,
  devLoginPassword: process.env.DEV_LOGIN_PASSWORD,
  devLoginURL: process.env.DEV_LOGIN_URL,
  devLoginSiteId: process.env.DEV_LOGIN_SITE_ID,
  mobilePunchURL: process.env.GEOFENCE_MANAGEMENT_EMBED_URL,
  timecardEmbedURL: process.env.TIMECARD_EMBED_URL,
  employeeDashboardEmbedUrl: process.env.EMPLOYEE_DASHBOARD_EMBED_URL,
  dashboardEmbedURL: process.env.DASHBOARD_EMBED_URL,
  logoURL: process.env.LOGO_URL,
  billingApiUrl: process.env.BILLINGAPI_URL,
  amplitudeApiKey: process.env.AMPLITUDE_API_KEY,
  twpLogoutUrl: process.env.TWP_LOGOUT_URL,
  webclockLoginUrl: process.env.WEBCLOCK_LOGIN_URL,
  clockServiceUrl: process.env.CLOCK_SERVICE_URL,
  essUrl: process.env.ESS_URL,
  urlESS: process.env.URL_ESS,
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
  stripePublishableTestKey: process.env.STRIPE_PUBLISHABLE_TEST_KEY,
  intercomAppId: process.env.INTERCOM_APP_ID,
  amplitudeWFHApiKey: process.env.AMPLITUDE_WFH_API_KEY,
  wfhApiUrl: process.env.WFHAPI_URL,
  hubComponentsEmbedUrl: process.env.HUB_COMPONENTS_EMBED_URL,
  hubApiUrl: process.env.HUB_API_URL,
  wfhUiUrl: process.env.WFHUI_URL,
  // twpInternalApiKey: process.env.TWP_INTERNAL_API_KEY,
  essUIUrl: process.env.ESSUI_URL,

  tsApiUserUrl: ({ site, hasEmployeeRole }) => {
    const userText = hasEmployeeRole ? '/user/' : '/';
    return `${process.env.TS_API_URL}${userText}${site}`;
  },

  twpApiUrl: (user) => {
    const { usingLeadershipRole, site } = user;
    const appendId = usingLeadershipRole ? '/users' : `/${site}`;
    return `${process.env.TWP_API_URL}${appendId}`;
  },

  twpEmployeeAPI: (user) => {
    const { site } = user;
    return `${process.env.TWP_API_URL}/${site}`;
  },

  twpApiUrlFinalizedPayPeriod: (user) => {
    const { site } = user;
    return `${process.env.TWP_API_URL}/sites/${site}`;
  },

  twpSettingsApiUrl: (user) => {
    const { usesTWPSettings, isEmployeeExclusive, site } = user;
    if (usesTWPSettings) {
      return `${process.env.TWP_API_URL}/users/master`;
    }

    const appendId = !isEmployeeExclusive ? '/users' : `/${site}`;
    return `${process.env.TWP_API_URL}${appendId}`;
  },

  twpEmployeeScheduleApiUrl: (user) => {
    const { site } = user;
    return `${process.env.TWP_API_URL}/${site}`;
  },

  // These are being used currently by scheduler.api.js
  twpAPIForEmployeeSchedule: (site) => {
    return `${process.env.TWP_API_URL}/${site}`;
  },
  tsAPI: (site, user = undefined) => {
    const appendUser = user !== undefined ? `/user` : '';
    return `${process.env.TS_API_URL}${appendUser}/${site}`;
  },
  timeSimplicityURL: () => {
    return `${process.env.TIMESIMPLICITY_URL}`;
  },
  twpEmployeeScheduleApiUrl: (user) => {
    const { site } = user;
    return `${process.env.TWP_API_URL}/${site}`;
  },
};
